import SmallButton from '@/app/common/components/SmallButton';
import SubtleBadge from '@/components/common/SubtleBadge';
import timeStampToDate from '@/helpers/timeStampToDate';
import { useChangeReportAccessMutation } from '@/app/Report/api/reportApi';
import { errorMessage } from '@/utils/toast';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { MdCheck, MdContentCopy, MdOutlineOpenInNew } from 'react-icons/md';
import useDomain from '@/hooks/useDomain';
import type {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams
} from 'ag-grid-community';
import type { ReportHistoryItem } from '@/app/Report/types/reportApiTypes';
import { toPersianDigit } from '@/helpers/utils';

type HistoryReportColumn = ColDef<ReportHistoryItem> & {
  searchable?: boolean;
  title?: string;
  type?: string;
  noFilter?: boolean;
};

export const historyReportColumnConfig: HistoryReportColumn[] = [
  {
    title: 'دامنه',
    field: 'domain_url',
    type: 'string',
    minWidth: 150,
    flex: 1
  },
  {
    title: 'تاریخ ایجاد',
    searchable: false,
    floatingFilter: true,
    field: 'update_date',
    type: 'string',
    width: 155,
    valueFormatter: (params: ValueFormatterParams<ReportHistoryItem>) =>
      toPersianDigit(timeStampToDate(Number(params.value)).slice(8))
  },
  {
    field: 'num_of_keywords',
    type: 'number',
    title: 'تعداد کلمات',
    width: 130,
    searchable: true
  },
  {
    title: 'نوع گزارش',
    searchable: true,
    field: 'is_public',
    type: 'boolean',
    width: 130,
    cellRenderer: (params: ICellRendererParams<ReportHistoryItem>) => {
      return (
        <div className="w-100 fs-0 h-100 d-flex justify-content-center align-items-center ">
          {params.value === false ? (
            <SubtleBadge bg="danger">خصوصی</SubtleBadge>
          ) : params.value === true ? (
            <SubtleBadge bg="info">عمومی</SubtleBadge>
          ) : (
            ''
          )}
        </div>
      );
    }
  },
  {
    field: 'actions',
    type: 'array',
    sortable: false,
    title: 'عملیات',
    width: 250,
    pinned: 'left',
    searchable: false,
    noFilter: true,
    cellRenderer: (params: ICellRendererParams<ReportHistoryItem>) => {
      const { domain_slug } = useDomain();
      const [accessChange] = useChangeReportAccessMutation();
      const [copied, setCopied] = useState(false);
      return (
        <>
          <div className="d-flex h-100 justify-content-center align-items-center gap-2">
            <SmallButton
              onClick={() => {
                navigator.clipboard
                  .writeText(
                    `${import.meta.env.VITE_REACT_APP_MIZFA_TOOLS_PANEL_URL}/reporting/tracker/${params.data?.id}`
                  )
                  .then(() => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 3000);
                  });
              }}
            >
              {copied ? (
                <MdCheck size={18} />
              ) : (
                <MdContentCopy
                  title="کپی پیوند"
                  className="cursor-pointer little-icon"
                  style={{ paddingLeft: '3px' }}
                  size={18}
                />
              )}{' '}
            </SmallButton>
            <SmallButton
              onClick={() => {
                try {
                  window.open(
                    decodeURI(
                      `${import.meta.env.VITE_REACT_APP_MIZFA_TOOLS_PANEL_URL}/reporting/tracker/${params.data?.id}`
                    ),
                    '_blank'
                  );
                } catch (error) {
                  errorMessage('.پیوند قابل بازکردن نمی‌باشد');
                  console.error('خطا در بازکردن پیوند:', error);
                }
              }}
            >
              <MdOutlineOpenInNew
                title="بازکردن پیوند"
                className="cursor-pointer little-icon"
                style={{ paddingLeft: '3px' }}
                size={18}
              />
            </SmallButton>
            <Form.Select
              size="sm"
              defaultValue={params.data?.is_public ? 'public' : 'private'}
              onChange={({ target }) => {
                if (!params.data || !domain_slug) return;
                accessChange({
                  is_public: target.value === 'public',
                  domain_slug,
                  update_date: params.data.update_date
                });
              }}
            >
              <option value="public">عمومی</option>
              <option value="private">خصوصی</option>
            </Form.Select>
          </div>
        </>
      );
    }
  }
];
